export const sanitizeInput = (inputValue, type, maxLength = 255) => {
    let sanitizedValue = inputValue;

    if (type === "number") {
        sanitizedValue = inputValue.replace(/[^0-9.]/g, "");
        const parts = sanitizedValue.split(".");
        if (parts.length > 1) {
            sanitizedValue = parts[0] + "." + parts.slice(1).join("").replace(/\./g, ""); 
        }
    }
    if (type === "text") sanitizedValue = inputValue.replace(/[^a-zA-Z0-9 ]/g, "");
    if (type === "textarea") sanitizedValue = inputValue.replace(/[^a-zA-Z0-9.,!"';:?\n\s]/g, ""); 
    if (type === "email") sanitizedValue = inputValue.replace(/[^a-zA-Z0-9@._-]/g, ""); 
    if (type === "giftcardTitle") sanitizedValue = inputValue.replace(/[^a-zA-Z0-9 !-]/g, "");

    // Apply length restriction, except for textarea
    return type === "textarea" ? sanitizedValue : sanitizedValue.substring(0, maxLength);
};
